export const Types = {
  GET_SPARE_PART_LIST: "GET_SPARE_PART_LIST",
  SET_SPARE_PART_LIST: "SET_SPARE_PART_LIST",

  GET_SPARE_PART_USAGE_LIST: "GET_SPARE_PART_USAGE_LIST",
  SET_SPARE_PART_USAGE_LIST: "SET_SPARE_PART_USAGE_LIST",

  GET_SPARE_PART_USAGE_PLANNED_LIST: "GET_SPARE_PART_USAGE_PLANNED_LIST",
  SET_SPARE_PART_USAGE_PLANNED_LIST: "SET_SPARE_PART_USAGE_PLANNED_LIST",

  GET_SELECTED_SPARE_PART_LIST: "GET_SELECTED_SPARE_PART_LIST",
  SET_SELECTED_SPARE_PART_LIST: "SET_SELECTED_SPARE_PART_LIST",

  GET_POOL_LIST_FOR_SPARE_PART_LIST: "GET_POOL_LIST_FOR_SPARE_PART_LIST",
  SET_POOL_LIST_FOR_SPARE_PART_LIST: "SET_POOL_LIST_FOR_SPARE_PART_LIST",
  SAVE_SPARE_PART: "SAVE_SPARE_PART",

  GET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS:
    "GET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS",
  SET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS:
    "SET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS",

  ADD_SPARE_PART: "ADD_SPARE_PART",
  UPDATE_SPARE_PART: "UPDATE_SPARE_PART",
  DELETE_SPARE_PART: "DELETE_SPARE_PART",

  DELETE_SPARE_PART_RES: "DELETE_SPARE_PART_RES",
  ADD_SPARE_PART_RES: "ADD_SPARE_PART_RES",
  RESET_DELETED_SP: "RESET_DELETED_SP",

  IS_UPDATED_TASK: "IS_UPDATED_TASK",
  RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",

  UPDATE_SPARE_PART_SUCCESS: "UPDATE_SPARE_PART_SUCCESS",
  GET_SPARE_PART_LOG_LIST: "GET_SPARE_PART_LOG_LIST",
  SET_SPARE_PART_LOG_LIST: "SET_SPARE_PART_LOG_LIST",

  SET_SPARE_PART_NOTE_LIST: "SET_SPARE_PART_NOTE_LIST",
  GET_SPARE_PART_NOTE_LIST: "GET_SPARE_PART_NOTE_LIST",
  ADD_SPARE_PART_NOTE: "ADD_SPARE_PART_NOTE",
  UPDATE_SPARE_PART_NOTE: "UPDATE_SPARE_PART_NOTE",
  DELETE_SPARE_PART_NOTE: "DELETE_SPARE_PART_NOTE",
  SET_DELETE_SPARE_PART_NOTE: "SET_DELETE_SPARE_PART_NOTE",
};

export const getSparePartList = (payload) => ({
  type: Types.GET_SPARE_PART_LIST,
  payload,
});

export const setSparePartList = (payload) => ({
  type: Types.SET_SPARE_PART_LIST,
  payload,
});

export const getSparePartUsageList = (payload) => ({
  type: Types.GET_SPARE_PART_USAGE_LIST,
  payload,
});

export const setSparePartUsageList = (payload) => ({
  type: Types.SET_SPARE_PART_USAGE_LIST,
  payload,
});

export const getSelectedSparePartList = (payload) => ({
  type: Types.GET_SELECTED_SPARE_PART_LIST,
  payload,
});

export const setSelectedSparePartList = (payload) => ({
  type: Types.SET_SELECTED_SPARE_PART_LIST,
  payload,
});

export const addSparePart = (payload) => {
  return {
    type: Types.ADD_SPARE_PART,
    payload: payload,
  };
};

export const updateSparePart = (payload) => {
  return {
    type: Types.UPDATE_SPARE_PART,
    payload: payload,
  };
};

export const updateSparePartSuccess = (payload) => ({
  type: Types.UPDATE_SPARE_PART_SUCCESS,
  payload,
});

export const deleteSparePart = (payload) => {
  return {
    type: Types.DELETE_SPARE_PART,
    payload: payload,
  };
};

export const deleteSparePartRes = (payload) => ({
  type: Types.DELETE_SPARE_PART_RES,
  payload: payload,
});

export const addSparePartRes = (payload) => ({
  type: Types.ADD_SPARE_PART_RES,
  payload: payload,
});

export const resetDelSp = () => ({
  type: Types.RESET_DELETED_SP,
});

export const getPoolList = () => ({
  type: Types.GET_POOL_LIST_FOR_SPARE_PART_LIST,
});

export const setPoolList = (payload) => ({
  type: Types.SET_POOL_LIST_FOR_SPARE_PART_LIST,
  payload,
});

export const getSparePartUsagePlannedList = (payload) => ({
  type: Types.GET_SPARE_PART_USAGE_PLANNED_LIST,
  payload,
});

export const setSparePartUsagePlannedList = (payload) => ({
  type: Types.SET_SPARE_PART_USAGE_PLANNED_LIST,
  payload,
});
export const saveSparePart = (payload) => ({
  type: Types.SAVE_SPARE_PART,
  payload: payload,
});

export const getListStockCodesAndMaterialDescriptions = () => ({
  type: Types.GET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS,
});

export const setListStockCodesAndMaterialDescriptions = (payload) => ({
  type: Types.SET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS,
  payload,
});

export const isUpdateTask = (payload) => ({
  type: Types.IS_UPDATED_TASK,
  payload,
});

export const resetIsUpdateTask = (payload) => ({
  type: Types.RESET_IS_UPDATED_TASK,
  payload,
});

export const getSparePartLogList = (payload) => ({
  type: Types.GET_SPARE_PART_LOG_LIST,
  payload,
});

export const setSparePartLogList = (payload) => ({
  type: Types.SET_SPARE_PART_LOG_LIST,
  payload,
});

export const setSparePartNoteList = (payload) => ({
  type: Types.SET_SPARE_PART_NOTE_LIST,
  payload
});


export const getSparePartNoteList = (payload) => ({
  type: Types.GET_SPARE_PART_NOTE_LIST,
  payload
});


export const saveSparePartNote = (payload) => ({
  type: Types.ADD_SPARE_PART_NOTE,
  payload
});

export const updateSparePartNote = (payload) => {
  return {
    type: Types.UPDATE_SPARE_PART_NOTE,
    payload: payload,
  }
};

export const deleteSparePartNote = (id) => ({
  type: Types.DELETE_SPARE_PART_NOTE,
  payload: id
});

export const setSparePartNoteDelete = (id) => ({
  type: Types.SET_DELETE_SPARE_PART_NOTE,
  payload: id
});
